import { useState } from "react";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import QuoteModal from "../home/components/QuoteModal";
import AboutHero from "./components/AboutHero";
import AboutStory from "./components/AboutStory";
import AboutValues from "./components/AboutValues";
import AboutTeam from "./components/AboutTeam";
import AboutEnvironment from "./components/AboutEnvironment";

export default function AboutPage() {
  const [quoteOpen, setQuoteOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar onBookNow={() => setQuoteOpen(true)} />

      <main className="flex-1">
        <AboutHero />
        <AboutStory />
        <AboutValues />
        <AboutTeam />
        <AboutEnvironment />

        {/* Final CTA */}
        <section className="py-16 bg-cl-dark">
          <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
            <div className="bg-cl-lime rounded-3xl px-8 py-12 thick-border cartoon-shadow flex flex-col lg:flex-row items-center justify-between gap-8">
              <div>
                <h3 className="text-cl-dark font-black text-3xl mb-2">Ready to clear the clutter?</h3>
                <p className="text-cl-dark/65 font-semibold text-base">
                  Same-day slots available. Fixed prices. 95%+ recycled.
                </p>
              </div>
              <div className="flex flex-wrap items-center gap-4">
                <a
                  href="/book"
                  className="flex items-center gap-2 bg-cl-dark text-white font-black px-8 py-4 rounded-full text-sm cartoon-btn whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-price-tag-3-line"></i>
                  Get a quote
                </a>
                <a
                  href="/contact"
                  className="flex items-center gap-2 bg-white text-cl-dark font-black px-8 py-4 rounded-full text-sm thick-border cartoon-shadow-sm hover:bg-cl-tint transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line"></i>
                  Call us
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <QuoteModal isOpen={quoteOpen} onClose={() => setQuoteOpen(false)} />
    </div>
  );
}
